import {Modal, InputNumber, Select, Row} from 'antd';
import {useState} from 'react';

export const TransferModal = ({roomOptions, open, defaultCount, onOk, onCancel, max}) => {
    const [numTransfer, setNumTransfer] = useState(defaultCount);
    const [roomId, setRoomId] = useState(undefined);

    const onChange = (val) => {
        setNumTransfer(val);
    }

    const onRoomChange = (val) => {
        setRoomId(val)
    }

    const onModalOk = () => {
        if (onOk) {
            onOk(numTransfer, roomId);
        }
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const disabled = roomOptions.length === 0;

    return <Modal title={`Enter the Number of Plants to Transfer`} open={open} onOk={onModalOk} onCancel={onCancel}>
        <Row style={rowStyle}>
            <InputNumber min={0} max={max} precision={0} onChange={onChange} value={numTransfer}/>
        </Row>
        <Row style={rowStyle}>
            <Select value={roomId} placeholder={'Destination'} options={roomOptions} onChange={onRoomChange} popupMatchSelectWidth={false} disabled={disabled}/>
        </Row>
    </Modal>
}